export function extractFilename(
  contentDisposition?: string,
  fallbackPrefix = "export",
  ext = "xlsx"
) {
  const cd = contentDisposition ?? "";
  const m = /filename\*=UTF-8''([^;]+)|filename="?([^"]+)"?/i.exec(cd);
  const raw = (m && (m[1] || m[2])) || "";
  const decoded = raw ? decodeURIComponent(raw) : "";
  if (decoded) return decoded;

  const date = new Date().toISOString().slice(0, 10);
  return `${fallbackPrefix}_${date}.${ext}`;
}

export function triggerDownload(data: BlobPart, filename: string) {
  const blob = new Blob([data]);
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}
